/** Title-case each word (e.g. `male` → `Male`, `non binary` → `Non Binary`). */
export function formatDisplayText(value: unknown, fallback = "-"): string {
  if (value == null) return fallback;

  const text = String(value).trim();
  if (!text) return fallback;

  return text
    .replace(/_/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** @deprecated Prefer `formatDisplayText` for new display formatting. */
export function capitalizeWords(value: string): string {
  return formatDisplayText(value, "");
}
